import React, { createContext, useContext } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var LanguageCode = /*#__PURE__*/function (LanguageCode) {
  LanguageCode["EN"] = "en";
  return LanguageCode;
}({});
var TranslateContext = /*#__PURE__*/createContext({
  translate: key => key
});
var TranslateConsumer = TranslateContext.Consumer;
function TranslateProvider(_ref) {
  var {
    children,
    translate
  } = _ref;
  var translateContextValue = {
    translate
  };
  return ___EmotionJSX(TranslateContext.Provider, {
    value: translateContextValue
  }, children);
}

// TODO: DEPRECATED
// DEPRECATED!
function withAngularJsTranslate(Component, translateServiceName) {
  if (translateServiceName === void 0) {
    translateServiceName = 'translateFilter';
  }
  // TODO: Should we actually migrate this to withI18NextTranslate?
  // Warning is too spammy in the logs so we must comment this out.
  // console.warn(
  //     'withAngularJsTranslate has been deprecated in preference for withI18NextTranslate. Are you sure you want to use this?'
  // );

  var WrappedTranslateComponent = props => ___EmotionJSX(TranslateProvider, {
    translate: props[translateServiceName]
  }, ___EmotionJSX(Component, props));
  return WrappedTranslateComponent;
}
function withTranslate(Component, translateService) {
  var WrappedTranslateComponent = props => ___EmotionJSX(TranslateProvider, {
    translate: translateService
  }, ___EmotionJSX(Component, props));
  var name = Component.displayName || Component.name;
  WrappedTranslateComponent.displayName = "withTranslate" + name;
  return WrappedTranslateComponent;
}
function useTranslate() {
  var translateContext = useContext(TranslateContext);
  return translateContext.translate;
}
export { TranslateContext, TranslateProvider, TranslateConsumer, useTranslate, withAngularJsTranslate, withTranslate };